import {component} from '../form/Constant'

export const keys = {
    name: 'name',
    description: 'description',
    hospital: 'hospital',
    selectedParticipants: 'selectedParticipants',
}

export const supportTeamList = [
    {
        key: 'information',
        description: 'Fill in the support team information details.',
        required: true,
        children: [
            {
                key: keys.name,
                required: true,
                component: component.inputText,
                placeholder: "Input support teams's name - Field is required",
            },
            {
                key: keys.description,
                component: component.inputText,
                placeholder: 'Input description',
            },
            {
                key: keys.hospital,
                component: component.dropdown,
                required: true,
                options: [],
                placeholder: 'Select hospital(s) - Field is required',
            },
        ],
    },
    {
        key: 'participants',
        description: 'Choose the participants assigned to the support teams',
        required: true,
        children: [
            {
                key: keys.selectedParticipants,
                component: component.multiSelect,
                required: true,
                options: [],
                placeholder: 'Select participant(s) - Field is required',
            },
        ],
    },
]
